import React, { useState } from "react";
import "./Navbar.scss";
import { BiAlignLeft } from "react-icons/bi";
import { HiX } from "react-icons/hi";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <>
      <div className="app__navbar">
        <div className="app__navbar-logo">
          <h2>
            <a href={"/"}>iNotes</a>
          </h2>
        </div>
        <div className="app__navbar-navigation">
          <ul className="app__navbar-links">
            {["home", "about"].map((item) => (
              <li className="app__flex" key={`link-${item}`}>
                <div />
                <a href={`/${item === "home" ? "" : item}`}>{item}</a>
              </li>
            ))}
          </ul>
          <div>
            <button className="primary_button">Sign in</button>
            <button className="primary_button">Sign up</button>
          </div>
        </div>
        <div className="app__navbar-menu">
          <BiAlignLeft
            onClick={() => {
              setToggle(true);
            }}
          />
          {toggle && (
            <div>
              <HiX
                onClick={() => {
                  setToggle(false);
                }}
              />
              <ul>
                {["home", "about"].map((item) => (
                  <li key={`link-${item}`}>
                    <a
                      href={`/${item === "home" ? "" : item}`}
                      onClick={() => {
                        setToggle(false);
                      }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
              <span>
                <button
                  onClick={() => {
                    setToggle(false);
                  }}
                  className="primary_button active"
                >
                  Sign in
                </button>
                <button
                  onClick={() => {
                    setToggle(false);
                  }}
                  className="primary_button active"
                >
                  Sign up
                </button>
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;
